import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Grid, Typography } from '@material-ui/core';
import { useGetBooksQuery } from '../store/apiSlice';
import React, { useEffect, useState } from 'react';

import { BookForm } from '../components/BookForm';
import { PageNav } from '../components/pageNav';
import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';

// mui table imports
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Skeleton } from '@material-ui/lab/';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  grid: {
    borderColor: theme.palette.secondary,
    borderBottom: '1px solid',
    marginTop: theme.spacing(1),
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

function Catalogue() {
  const classes = useStyles();
  const [pageInput, setPageInput] = useState(1);
  const [settings, setSettings] = useState({ page: 1 });

  const { data: bookData, isFetching } = useGetBooksQuery({
    ...settings,
    page: pageInput,
  });

  const firstResultRef = useRef(null);
  const errorMessageRef = useRef(null);

  useEffect(() => {
    if (bookData && bookData.books.length > 0) {
      // if (firstResultRef.current) firstResultRef.current.focus();
    } else if (!books.length) {
      errorMessageRef.current.tabIndex = 0;
      errorMessageRef.current.focus();
    }

    console.log(settings);
  }, [bookData]);

  useEffect(() => {
    setPageInput(1);
  }, [settings]);

  const handlePageMove = (sign) => () => {
    setPageInput((prevState) => prevState + 1 * sign);
  };

  const handleInputChange = (e) => {
    e.persist();
    const newValue = Math.min(
      Math.max(e.target.value, 1),
      bookData?.pageCount || pageInput
    );
    setPageInput(newValue);
  };

  let books = bookData?.books || Array.from({ length: 20 });

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Helmet>
        <title>Каталог</title>
      </Helmet>

      <Container maxWidth="lg" className={classes.container}>
        <Paper className={classes.paper}>
          <Typography
            className={classes.title}
            component="h1"
            variant="h4"
            role="alert"
          >
            Каталог
          </Typography>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="Каталог">
              <TableHead>
                <TableRow>
                  <TableCell>Заглавие</TableCell>
                  <TableCell>Автор</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {books.map((book, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row">
                      {!isFetching ? (
                        <Link
                          ref={firstResultRef}
                          to={`../catalogue/${book.id}`}
                        >
                          {book.title}
                        </Link>
                      ) : (
                        <Skeleton width={'25vw'} />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {!isFetching ? (
                        book.author?.name
                      ) : (
                        <Skeleton width={'25vw'} />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {books.length ? (
            <PageNav
              isFetching={isFetching}
              maxPage={bookData?.pageCount}
              handlePageMove={handlePageMove}
              pageInput={pageInput}
              handleInputChange={handleInputChange}
            />
          ) : (
            <Typography ref={errorMessageRef}>Няма намерени книги.</Typography>
          )}
          <BookForm setSettings={setSettings} />
        </Paper>
      </Container>
    </div>
  );
}

export default Catalogue;
